import { Button } from '../../../../components/Button/Button'
import React, { useCallback } from 'react'
import { Modal } from '../../../../components/Modal/Modal'
import { Nullable } from '../../../../common/Nullable'
import { type ComplianceFileType } from './ComplianceNoticeFile'

type ComplianceFileDisplayModalProps = {
  complianceFile: Nullable<Blob>
  show: boolean
  onHide: () => void
  type: Nullable<ComplianceFileType>
}

export const ComplianceFileDisplayModal: React.FC<ComplianceFileDisplayModalProps> = ({ show, onHide, complianceFile, type }) => {
  const modalFooter = (
    <div className='d-flex gap-3'>
      <Button variant='secondary' onClick={onHide}>
        Close
      </Button>
    </div>
  )

  const renderBody = useCallback(() => {
    if (!complianceFile || !type) {
      return <></>
    }
    const fileUrl = URL.createObjectURL(complianceFile)
    if (type === 'audio') {
      return (
        <div className='text-center p-4'>
          <audio controls>
            <source src={fileUrl} type={complianceFile.type} />
            Your browser does not support the audio element.
          </audio>
        </div>
      )
    } else if (type === 'image') {
      return (
        <div className='text-center p-4'>
          <img className='img-fluid' alt='' src={fileUrl} />
        </div>
      )
    } else {
      return <></>
    }
  }, [complianceFile, type])

  const renderDefaultBody = useCallback(() => {
    if (type === 'audio') {
      return (
        <div className='text-center p-4'>
          <audio controls>
            <source src='https://static.zocks.io/assets/compliance/default_compliance_audio.wav' type='audio/wav' />
            Your browser does not support the audio element.
          </audio>
        </div>
      )
    } else if (type === 'image') {
      return (
        <div className='text-center p-4'>
          <img className='img-fluid' alt='' src='https://static.zocks.io/assets/compliance/default_compliance_image.png' />
        </div>
      )
    } else {
      return <></>
    }
  }, [type])

  return (
    <Modal
      size={type === 'image' ? 'lg' : undefined}
      show={show}
      onHide={onHide}
      body={complianceFile ? renderBody() : renderDefaultBody()}
      showFooterActions={false}
      footer={modalFooter}
      centered={true}
    />
  )
}
